<template>
  <div class="page-content header-clear-medium">
    <div v-if="loading">
        <EnvelopeItemSekeleton />
    </div>
    <div v-else class="card card-style mt-5 overflow-visible p-3">
        <h3 class="text-center">{{ surat_masuk[0].pengirim }}</h3>
        <div class="d-flex justify-content-between">
            <button class="btn btn-outline-primary text-black"><i class="bi bi-person"></i> {{ surat_masuk[0].perihal }}</button>
            <p class="text-center">{{ surat_masuk[0].tgl_surat }}</p>
        </div>
        <a target="_blank" :href="surat_masuk[0].url_berkas" class="btn btn-primary mx-auto">Lihat Surat</a>

        <p><b>Progres Surat</b></p>
        <div v-for="(item, index) in surat_masuk[0].status" :key="index">
            <p class="progres">{{ item.user.nama }} update status surat : {{ item.ket }}</p>
            <p class="progres">{{ item.created | getDateIndoWithDayAndTime }}</p>
        </div>

        <table class="table table-bordered mt-2">
            <thead>
                <tr>
                    <th>Disposisi Dari</th>
                    <th>Tujuan</th>
                    <th>Catatan</th>
                    <th>Waktu</th>
                </tr>
            </thead>
            <tbody>
                <!-- <tr v-for="(item, index) in surat_masuk[0].memo" :key="index">
                    <td>{{ surat_masuk[0].user.nama }}</td>
                    <td>{{ note }}</td>
                    <td>{{ item.created | getDateIndoWithDay }}</td>
                </tr> -->
            </tbody>
        </table>

        <table>
            <tbody>
                <tr>
                    <td>Tgl Diterima</td>
                    <td>:</td>
                    <td>{{ surat_masuk[0].tgl_terima | getDateIndo }} </td>
                </tr>
                <tr>
                    <td>Dari</td>
                    <td>:</td>
                    <td>{{ surat_masuk[0].user.nama }}</td>
                </tr>
                <tr>
                    <td>Tgl Surat</td>
                    <td>:</td>
                    <td>{{ surat_masuk[0].tgl_surat }} | {{ surat_masuk[0].no_sm }}</td>
                </tr>
                <tr>
                    <td>Perihal</td>
                    <td>:</td>
                    <td>{{ surat_masuk[0].perihal }}</td>
                </tr>
                <tr>
                    <td>Keterangan</td>
                    <td>:</td>
                    <td>{{ surat_masuk[0].ket }}</td>
                </tr>
                <tr>
                    <td>Bukti Terima Surat</td>
                    <td>:</td>
                    <td>
                        <button class="btn btn-primary">Download</button>
                    </td>
                </tr>
                <tr>
                    <td>Detail Surat</td>
                    <td>:</td>
                    <td>
                        <a target="_blank" :href="surat_masuk[0].url_berkas" class="btn btn-primary">Download</a>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import EnvelopeItemSekeleton from "../components/skeleton/EnvelopeItemSekeleton.vue";
export default {
    name: 'EnvelopeShow',
    data() {
        return {}
    },
    components: {
        EnvelopeItemSekeleton
    },
    async created() {
        this.SET_LOADING();
        await this.getSuratMasuk({id: this.$route.params.id});
        await this.readSurat({id_sm: this.$route.params.id, kode: this.$route.params.kode});
		this.CLEAR_LOADING();
    },
    methods: {
        ...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
        ...mapActions('envelope', ['getSuratMasuk', 'readSurat'])
    },
    computed: {
        ...mapState({
            loading: state => state.loading
        }),
        ...mapState('envelope', {
            surat_masuk: state => state.surat_masuk
        })
    }
}
</script>

<style>
    .progres {
        margin-bottom: 0;
        margin-top: 0;
    }
</style>